<template>
  <div class="wd-100p ht-100p">
    <Header></Header>
    <div class="wd-100p ht-100p cr-hei">
      <div class="wd-100p ht-70"></div>
      <div class="wd-100p ht-100p-70 pos-r">
        <div class="wd-100p ht-100p cr-theme0">
          <div class="ht-100p pos-r ov-h ov-a-y" v-animate="{ name: 'bounceInLeft', delay: 0 }">
            <div class="wd-100p">
              <div class="max-wd-1000 dp-flex jus-c ht-60 mg-a font-24 fw cr-theme0">
                ROOM TYPES
              </div>
              <div class="max-wd-1000 mg-a pd-20 fx-w" v-for="(n, j) in virtualList" :key="j">
                <div class="font-20 fw">{{ n.title }}</div>
                <Row :gutter="10" class="dp-flex jus-c">
                  <Col :xs="12" :sm="12" v-for="(item, i) in n.list" :key="i">
                  <div class="wd-100p pd-t-30 pointer" @click="tiggerVirtual(item)"
                    v-animate="{ name: 'bounceInLeft', delay: 100 * i }">
                    <div class="wd-100p dp-flex jus-c">
                      <img class="wd-90p" :src="require('@/assets/virtual/' + item.img)" />
                    </div>
                    <div class="ht-60 txt-ali-c dp-flex jus-c Roboto s-name">
                      {{ item.name }}
                    </div>
                  </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div class="wd-100p pd-40 bg-white">
              <div class="max-wd-1440 mg-a pointer lht-0" @click="tiggerVirtual()">
                <img v-if="$store.state.mob" class="wd-100p" :src="require('@/assets/virtual/banner_mob.jpg')" />
                <div v-else class="pd-20">
                  <img class="wd-100p" :src="require('@/assets/virtual/banner.jpg')" />
                </div>
              </div>
            </div>
            <!-- <div class="wd-100p">
              <div class="max-wd-1440 mg-a pd-20 txt-ali-c">
                <div class="max-wd-800 mg-a font-14">
                  <p class="mg-t-20">
                    Located in the exclusive Phu My Hung area in District 7,
                    Capri by Fraser Ho Chi Minh City’s elegantly appointed
                    serviced apartments are an oasis of tranquility away from
                    the chaos of the city centre.
                  </p>
                </div>
                <div class="max-wd-800 mg-a font-14" v-if="more">
                  <p>
                    <br />
                    Available in studio, one- and two-bedroom options, the sleek
                    and contemporary fully-furnished apartments feature an open
                    plan layout with integrated or separate living and bedroom
                    areas. A fully-equipped kitchenette, ensuite bathroom,
                    comprehensive home entertainment system and a spacious work
                    desk with complimentary Wi-Fi and LCD TV, are just some of
                    the thoughtful touches for a comfortable short or long stay.
                  </p>
                </div>

                <p class="cr-theme0 font-16 fw mg-t-30 pointer" @click="readMore">
                  <span v-if="!more">READ MORE</span><span v-else>READ LESS</span>
                </p>
              </div>
            </div> -->
            <div class="wd-100p pd-40 bg-3">
              <div class="max-wd-1440 mg-a">
                <Row :gutter="8">
                  <Col :xs="24" :sm="24">
                  <div class="dp-flex ht-100p pd-10">
                    <div class="cr-theme0 Roboto font-14">
                      <div class="fw">
                        <!-- Getting here<br /> -->
                        <b class="fong-20">FRASER RESIDENCE HANOI</b><br />
                        <div class="font-16">
                          C5, Do Nhuan Street, Xuan Dinh Ward, Bac Tu Liem District, Hanoi, Vietnam
                        </div>
                      </div>
                      <br />
                      Tel :+84 24 3275 0888
                      <br />
                      Fax: +84 24 3275 0899
                      <br />
                      Reservation Hotline No: +84 24 3275 0800

                      <br />
                      <span class="">Email: </span>
                      <a class="cr-theme0" href="mailto:reservations.xuandinh-hanoi@frasershospitality.com">
                        <u>reservations.xuandinh-hanoi@frasershospitality.com</u></a>
                      <br /><br />
                      <hr />
                      <div class="dp-flex Roboto pd-t-20">
                        <img :src="require('@/assets/virtual/icon_plane.png')" class="mg-r5" />
                        Airport transfer is available on request
                      </div>
                    </div>
                    <div class="fx-1"></div>
                  </div>
                  </Col>
                  <!-- <Col :xs="24" :sm="14">
                  <div class="dp-flex jus-e">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3920.051538447459!2d106.72017605739218!3d10.73050845517645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x317525627ede7977%3A0x89641a121098c89b!2sCapri%20by%20Fraser%2C%20Ho%20Chi%20Minh!5e0!3m2!1sen!2ssg!4v1666751175447!5m2!1sen!2ssg"
                      width="600" height="450" style="border: 0" allowfullscreen="" loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                  </Col> -->
                </Row>
              </div>
            </div>

            <!-- <Footer v-animate="{ name: 'bounceInLeft', delay: 600 }" /> -->
          </div>
        </div>

        <div v-if="showVirtual" id="showVirtual" class="pos-a top-0 left-0 wd-100p ht-100p zindex-99 bg-white">
          <div class="pos-a zindex-99 top-0 right-0 bg-hei-02 dp-flex jus-c wd-40 ht-40 pointer" @click="tiggerVirtual()">
            <img :src="require('@/assets/close.png')" />
          </div>
          <iframe v-if="linkVirtual" class="wd-100p ht-100p" :src="linkVirtual" frameborder="0" allow=""
            allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MvFullPage from "@/components/MvFullPage/index.vue";
import Header from "@/components/header.vue";
import config from "@/config";
import Footer from "@/components/footer.vue";

export default {
  components: { MvFullPage, Header, Footer },
  data() {
    return {
      virtualList: [],
      linkVirtual: null,
      showVirtual: false,
      more: false,
      dynamicSlotName: "page",
      pages: 1, // 页面总数
      tempPage: 1,
      isV: true, //滚动的方向 true 为垂直方向，false 为左右方向
      page: 1, // 当前页面
      bgArr: [],
    };
  },
  methods: {
    pointerMouseover({ event, index }) {
      console.log(event, index);
    },
    onRollEnd(page) {
      // console.log("当前页面为", page);
    },
    toPage() {
      this.page = this.tempPage;
    },
    clickref(ref) {
      this.pushr(ref);
    },
    tiggerVirtual(item) {
      this.showVirtual = !this.showVirtual;
      if (!item) {
        item = {
          link: "./virtual-tour/index.htm",
        };
      }
      if (this.showVirtual) {
        this.linkVirtual = item.link;
      } else {
        this.linkVirtual = null;
      }
    },
    readMore() {
      this.more = !this.more;
    },
  },
  created() {
    this.virtualList = config.virtualList;
  },
  mounted() {
    this.$store.dispatch("getMob");
  },
  computed: {
    virtualLink() {
      return this.$store.state.virtualLink;
    },
  },
  watch: {
    virtualLink(val) {
      this.showVirtual = false;
      this.tiggerVirtual(val);
    },
  },
  beforeDestroy() { },
};
</script>

<style>
.s-name {
  font-size: 22px;
}

@media (max-width: 900px) {
  .pd-t-30 {
    padding-top: 10px;
  }

  .wd-220 {
    width: 120px;
  }

  .ht-150 {
    height: 110px;
  }

  .s-name {
    font-size: 14px;
  }

  .pd-40 {
    padding: 0px;
  }

  .font-40 {
    font-size: 8vw;
  }

  .font-1vw {
    font-size: 4.8vw;
  }

  .font-22 {
    font-size: 5.8vw;
  }

  .ft-s14 {
    font-size: 10px;
  }
}

@media (min-width: 376px) {
  .ivu-col-span-sm-4-8 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>